



































































































































































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import { Form } from 'element-ui'
import PlatformConfig from '@/store/modules/config'
import request from '@/utils/request'
import md5 from 'js-md5'
@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class extends Vue {
private dialogVisible:boolean= false;

  private passWordInfo = {
    oldpassWord: '',
    newpassWord: '',
    confirmPassWord: ''
  }
  private notice = {
    title: '',
    message: ''
  }
  private noticeVisible:any = false
  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device.toString()
  }

  get avatar() {
    return PlatformConfig.baseServerUrl + UserModule.avatar
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private async logout() {
    await UserModule.LogOut()
    console.log(this.$route.fullPath)
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    this.$router.push(`/login?redirect=1`)
  }

  private updatePassWord(formName: any) {
    (this.$refs[formName] as Form).validate((valid) => {
      if (valid) {
        var resetPassWordInfo = {
          oldpassWord: md5(this.passWordInfo.oldpassWord),
          newpassWord: md5(this.passWordInfo.newpassWord),
          confirmPassWord: md5(this.passWordInfo.confirmPassWord)
        }
        request({
          url: '/SysUser/UpdatePassWord',
          method: 'POST',
          data: resetPassWordInfo
        }).then((respone:any) => {
          if (respone.code === 200) {
            this.$message({
              message: '用户密码已重置！',
              type: 'success'
            })
            this.dialogVisible = false
          } else if (respone.code === 203) {
            this.$message({
              message: respone.msg,
              type: 'warning'
            })
          } else {
            this.$message({
              message: respone.msg,
              type: 'error'
            })
          }
        }).catch((response:any) => {
          console.log('失败')
        })
      } else {
        return false
      }
    })
  }

  private closeResetPassWordForm() {
    this.dialogVisible = false
  }
  // 重置密码验证
  private resetPassWordVerify = {
    newpassWord: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 16, max: 30, message: '密码长度在16~30之间', trigger: 'blur' },
      { validator: this.validatePassWord, trigger: 'blur' }
    ],
    confirmPassWord: [
      { required: true, message: '确认密码不能为空', trigger: 'blur' },
      { validator: this.validatePassWord, trigger: 'blur' }
    ]
  }
  private validatePassWord(rule: any, value: any, callback: Function) {
    var _chinese = new RegExp(/[\u4e00-\u9fa5]/)
    var _password = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~!@#$%^&*()\-\_=+\[\]{}|;:'",.<>\/?]).{16,30}$/)
    if (_chinese.test(value)) {
      callback(new Error('密码中不能包含汉字'))
    } else if (!_password.test(value)) {
      callback(new Error('密码必须包含大写英文、小写英文、数字、特殊字符'))
    } else {
      let ispass = true;
      // 2. 检查3位以上连续数字
      // 用滑动窗口检查
      for (let i = 0; i <= value.length - 3; i++) {
        const a = value.charCodeAt(i);
        const b = value.charCodeAt(i + 1);
        const c = value.charCodeAt(i + 2);
        // 检查是否都是数字
        if (
          value[i].match(/\d/) &&
          value[i+1].match(/\d/) &&
          value[i+2].match(/\d/)
        ) {
          // 升序
          if (b === a + 1 && c === b + 1) ispass = false;
          // 降序
          if (b === a - 1 && c === b - 1) ispass = false;
        }
      }
      // 3. 检查3位以上同一数字重复
      if (/\d{3,}/.test(value)) {  // 至少有3位数字连续
        for (let i = 0; i <= value.length - 3; i++) {
          const ch = value[i];
          if (/\d/.test(ch) && value[i+1] === ch && value[i+2] === ch) {
            ispass = false;
          }
        }
      }
      if (ispass) {
        callback()
      } else {
        callback(new Error('不允许出现3位以上连续数字或3位以上同一数字重复'))
      }
    }
  }
  private noticeView() {
    this.noticeVisible = true
  }
  private GetFirstNotice() {
    request({
      url: '/TNotice/GetFirstTNotice',
      method: 'GET'
    }).then((respone:any) => {
      if (respone.code === 200) {
        if (respone.data !== null && respone.data[0].enable === true) {
          this.notice.title = respone.data[0].title
          this.notice.message = respone.data[0].content
          this.noticeVisible = true
        }
      } else {
        this.$message({
          message: respone.message,
          type: 'error'
        })
      }
    }).catch((response:any) => {
      console.log('失败')
    })
  }
  created() {
    this.GetFirstNotice()
  }
  // mounted() {
  //   var menu = document.getElementById('hamburger-container').offsetWidth
  //   var Breadcrumb = document.getElementById('breadcrumb-container').offsetWidth
  //   var right = document.getElementById('right-menu').offsetWidth
  //   var total = document.getElementById('navbar').offsetWidth
  //   console.log(document.getElementById('hamburger-container').offsetWidth)
  //   console.log(document.getElementById('breadcrumb-container').offsetWidth)
  //   console.log(document.getElementById('right-menu').offsetWidth)
  //   console.log(document.getElementById('navbar').offsetWidth)
  //   document.getElementById('middle').style.width = (total - menu - Breadcrumb - right - 40) + 'px'
  //   console.log(total - menu - Breadcrumb - right - 40)
  //   window.onresize = () => {
  //     return (() => {
  //       var menu = document.getElementById('hamburger-container').offsetWidth
  //       var Breadcrumb = document.getElementById('breadcrumb-container').offsetWidth
  //       var right = document.getElementById('right-menu').offsetWidth
  //       var total = document.getElementById('navbar').offsetWidth
  //       console.log(document.getElementById('hamburger-container').offsetWidth)
  //       console.log(document.getElementById('breadcrumb-container').offsetWidth)
  //       console.log(document.getElementById('right-menu').offsetWidth)
  //       console.log(document.getElementById('navbar').offsetWidth)
  //       document.getElementById('middle').style.width = (total - menu - Breadcrumb - right - 40) + 'px'
  //       console.log(total - menu - Breadcrumb - right - 40)
  //     })()
  //   }
  // }
}
